// src/components/Spinner.js
import { cn } from "@/lib/utils";
import { VariantProps, cva } from "class-variance-authority";
import React, { FC, HTMLAttributes } from "react";
const spinnerVariants = cva(
  "border-4 border-blue-400 border-dashed rounded-full animate-spin",
  {
    variants: {
      size: {
        default: "w-10 h-10",
        sm: "w-5 h-5",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
);
interface SpinnerProps
  extends HTMLAttributes<HTMLElement>,
    VariantProps<typeof spinnerVariants> {}
const Spinner: FC<SpinnerProps> = ({ size, className }) => {
  return <div className={cn(spinnerVariants({ size, className }))}></div>;
};

export default Spinner;
